<template>
	<div class="ppts">
        <div class="item" v-for="(value,key,index) in pptList" :key="index">
            <video 
            :src="value.bind_url" 
            x5-video-player-type='h5-page' webkit-playsinline="true" playsinline="true"
            :poster="value.banner"
            preload="auto"
            controls></video>
            <span class="name">{{value.name}}</span>
			<div style="margin-top:5px;">
				<van-button :url="value.bind_url" icon="down" color="#d2020d" size="small" style="margin-right:20px">下载</van-button>
				<van-button icon="envelop-o"  size="small" plain color="#d2020d" @click="inputEmail(value.bind_url)">发送到邮箱</van-button>
			</div>

        </div>
		<van-overlay :show="show" @click="show = false">
            <div class="wrapper" >
                <div class="block" @click.stop>
                    <van-field v-model="email" label="邮箱" placeholder="我们将发送虚拟背景至您填写的邮箱" label-width="50px"></van-field>
                    <van-button round @click="sendPdf">确定发送</van-button>
                </div>
            </div>
        </van-overlay>
	</div>
</template>
<script>
	import {PPTs,ButtonDetail,sendPPTEmail} from '../../config/interface.js'
	export default{
		data(){
			return{
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
				button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
				pptList:[
                    {
                        bind_url:'//cdn.edstatic.com/203012120000/c56ee90dfc4eaf08dee01bcc1387ed02/2022/11/a899035a-5cac-4112-8ad6-a2dc9a02e346.mp4',
                        banner:'http://cdn.edstatic.com/203012120000/c778c7ac5c6722c0f6b7041f3a013036/2022/11/ee63953a-aa6b-42a2-8d64-6d178eea282d.jpg',
                        name:'动态-红底.mp4'
                    },
                    {
                        bind_url:'//cdn.edstatic.com/203012120000/69103d8bfd725348d193a947fe7b9cf7/2022/11/529604a7-da79-409a-91ef-b18b795c664d.mp4',
                        banner:'http://cdn.edstatic.com/203012120000/8ed2a8491dac0053bf997ebb6bcee518/2022/11/8f441154-48ed-4877-a7a7-68e419830de4.jpg',
                        name:'动态-黑底.mp4'
                    },
                    {
                        bind_url:'//cdn.edstatic.com/203012120000/8831e3c9c7275e87edf1e0be41ae18e4/2022/11/2f1f469e-01e0-459c-bf45-3d39ee93af27.mp4',
                        banner:'http://cdn.edstatic.com/203012120000/b8bb1904136cad113c96480b257ab37a/2022/11/901a2797-14d3-4e97-bdd0-0696c49eb113.jpg',
                        name:'动态-浅底.mp4'
                    }
                ],
				show:false,
				email:localStorage.getItem('email')?localStorage.getItem('email'):'',
				send_url:''
			}
		},
		mounted(){
            document.title='动态虚拟背景';
			this.getButtonData();
		},
		methods:{
            goTo(url){
				window.location.href=url;
			},
			inputEmail(url){
				this.show=true;
				this.send_url=url;
			},
			//获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
			sendPdf(){
                if(this.checkEmail(this.email)){
                    const url=sendPPTEmail;
				    const method='POST';
                    localStorage.setItem('email',this.email);
				    let params={
                        ppt_url:this.send_url,
						email:this.email,
                        type:'动态背景'

                    };
				    fetch(url,params,method)
				        .then((res)=>{
					    if(res.code==0){
							common.toast("发送成功", 1000, "success", () => {
								this.show=false;
							});
					    }
                        else{
                                common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{
                            })
                        }
				})

                }

            },
            checkEmail(val){
                // let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
                if(val === ""){ //输入不能为空
                    common.toast('请您填写邮箱',1000)
                    return false;
                }else{
                    return true;
                }
            },
			
		}
	}
</script>
<style lang="scss" scoped>
	.ppts{
        margin:15px;
        .item{
            margin-bottom:20px;
            video{
                width: 100%;
            }
            .name{
                font-size:18px;
                line-height: 36px;
            }

        }
    }
	.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 90%;
    height: 120px;
    background-color: #fff;
    padding: 10px;
    text-align: center;
    p{
        font-size:14px ;
    }
    .van-field{
        border-width:1px;
    }
    .van-button{
        text-align: center;
        background: $color-main;
        color: white;
        margin-top:10px ;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/dynamicBg.vue